export const MOBILE_STAGE_IMAGE = {
  url: 'https://images.ctfassets.net/f6c1mtmq4qrb/bC7a7rycZYnZYevJINdz2/d5d06f95bb291092de48236f7a572787/header-202609-mobile.png',
  altText: 'Kreditvergleich bei FINANZCHECK.de',
};
